import RealtimeTimeSeries from './realtime-time-series';

export default class TimeSeries {
    constructor(options) {
        this.timeSeriesInstance = new RealtimeTimeSeries(options);
    }
    price(params) {
        return this.timeSeriesInstance.price(params);
    }
}
